"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentLanguage = getCurrentLanguage;
exports.getCurrentLocale = getCurrentLocale;
exports.changeLanguage = changeLanguage;
var js_cookie_1 = __importDefault(require("js-cookie"));
var constants_1 = require("./constants");
function getCurrentLanguage(cookieKey) {
    var lang = js_cookie_1.default.get(cookieKey || constants_1.COOKIE_KEY_LOCALE);
    return lang || constants_1.SUPPORTED_LANGUGES.KO_KR;
}
function getCurrentLocale(cookieKey) {
    var lang = getCurrentLanguage(cookieKey);
    return constants_1.MAP_LANG_TO_LOCALE[lang];
}
function changeLanguage(lang, options, refresh, cookieKey) {
    if (options === void 0) { options = {}; }
    if (refresh === void 0) { refresh = true; }
    js_cookie_1.default.set(cookieKey || constants_1.COOKIE_KEY_LOCALE, lang, __assign({ expires: 30 }, options));
    if (refresh) {
        requestAnimationFrame(function () {
            window.location.reload();
        });
    }
}
